export default function NotificationBadge({ count, size = 'sm', className = '' }) {
  if (!count || count <= 0) return null;

  const sizeClasses = {
    xs: 'min-w-[14px] h-[14px] text-[9px]',
    sm: 'min-w-[18px] h-[18px] text-[10px]',
    md: 'min-w-[20px] h-[20px] text-xs',
  };

  return (
    <span
      className={`flex items-center justify-center px-1 rounded-full bg-red-500 text-white font-bold ${sizeClasses[size]} ${className}`}
    >
      {count > 9 ? '9+' : count}
    </span>
  );
}
